import React from 'react';
import { XCircle } from 'lucide-react';

const OrdersRejectModal = ({ REJECT_REASONS, confirmRejectOrder, customRejectMessage, isRejecting, rejectingOrder, selectedRejectReason, setCustomRejectMessage, setRejectingOrder, setSelectedRejectReason, setShowRejectModal }) => {
  return (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[100] p-4 animate-in fade-in duration-200">
          <div className="bg-gray-800 rounded-2xl w-full max-w-md border border-red-500/30 shadow-2xl animate-in zoom-in-95 duration-200">
            {/* Header */}
            <div className="p-5 border-b border-gray-700">
              <div className="flex items-center gap-3">
                <div className="p-3 bg-red-500/20 rounded-xl">
                  <XCircle className="w-6 h-6 text-red-400" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white">Rejeitar Pedido</h3>
                  <p className="text-sm text-gray-400">#{rejectingOrder.order_number}</p>
                </div>
              </div>
              <p className="text-sm text-gray-300 mt-3">
                Selecione o motivo da rejeição. O cliente será notificado via WhatsApp.
              </p>
            </div>

            {/* Motivos de Rejeição */}
            <div className="p-4 max-h-80 overflow-y-auto">
              <div className="grid grid-cols-2 gap-2">
                {REJECT_REASONS.map((reason) => (
                  <button
                    key={reason.id}
                    onClick={() => setSelectedRejectReason(reason.id)}
                    className={`p-3 rounded-xl border-2 transition-all text-left ${
                      selectedRejectReason === reason.id
                        ? 'bg-red-500/20 border-red-500 text-white'
                        : 'bg-gray-700/50 border-gray-600 text-gray-300 hover:border-gray-500 hover:bg-gray-700'
                    }`}
                    data-testid={`reject-reason-${reason.id}`}
                  >
                    <span className="text-2xl block mb-1">{reason.icon}</span>
                    <span className="text-sm font-medium">{reason.label}</span>
                  </button>
                ))}
              </div>

              {/* Campo de motivo personalizado */}
              {selectedRejectReason === 'outro' && (
                <div className="mt-4 animate-in slide-in-from-top duration-200">
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Descreva o motivo:
                  </label>
                  <textarea
                    value={customRejectMessage}
                    onChange={(e) => setCustomRejectMessage(e.target.value)}
                    placeholder="Digite aqui o motivo da rejeição..."
                    className="w-full p-3 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:border-red-500 focus:ring-1 focus:ring-red-500 resize-none"
                    rows={3}
                    data-testid="reject-custom-message"
                  />
                </div>
              )}
            </div>

            {/* Footer com botões */}
            <div className="p-4 border-t border-gray-700 flex gap-3">
              <button
                onClick={() => {
                  setShowRejectModal(false);
                  setRejectingOrder(null);
                  setSelectedRejectReason('');
                  setCustomRejectMessage('');
                }}
                disabled={isRejecting}
                className="flex-1 px-4 py-3 bg-gray-700 hover:bg-gray-600 text-white font-medium rounded-xl transition-all disabled:opacity-50"
                data-testid="reject-cancel-btn"
              >
                Cancelar
              </button>
              <button
                onClick={confirmRejectOrder}
                disabled={isRejecting || !selectedRejectReason || (selectedRejectReason === 'outro' && !customRejectMessage.trim())}
                className="flex-1 px-4 py-3 bg-red-500 hover:bg-red-600 text-white font-bold rounded-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                data-testid="reject-confirm-btn"
              >
                {isRejecting ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    Rejeitando...
                  </>
                ) : (
                  <>
                    <XCircle className="w-4 h-4" />
                    Confirmar Rejeição
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
  );
};

export default OrdersRejectModal;
